export const styles = {
  messageItem: {
    transform: 'rotate(180deg)',
    direction: 'ltr',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    background: 'none',
    padding: '0 16px',
  },
  messageItemAi: {
    maxWidth: '100%',
  },
  human: {
    justifyContent: 'flex-end',
    alignSelf: 'flex-end',
    borderRadius: 40,
    background: '#cccccc',
    margin: '4px 0',
  },
  messageItemHuman: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  messageHuman: {
    minWidth: '90px',
    padding: '8px 12px',
    borderRadius: '16px 0px 16px 16px',
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px',
  },
  button: {
    mt: '24px',
  },
  imageButton: {
    minWidth: 'initial',
    padding: '8px',
  },
};
